import { render, staticRenderFns } from "./GameItemPreview.vue?vue&type=template&id=7ba532e8&scoped=true&"
import script from "./GameItemPreview.vue?vue&type=script&lang=js&"
export * from "./GameItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./GameItemPreview.vue?vue&type=style&index=0&id=7ba532e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba532e8",
  null
  
)

export default component.exports